import {useEffect, useState} from 'react';

import {config} from '@/config';

declare const window: {
  LC_API: {
    open_chat_window: () => void;
    hide_chat_window: () => void;
    minimize_chat_window: () => void;
    hide_eye_catcher: () => void;
    is_loaded: () => boolean;
    chat_window_hidden: () => boolean;
  };
};

export const useLiveChat = () => {
  const [isWidgetLoaded, setIsWidgetLoaded] = useState(false);

  useEffect(() => {
    if (!config.liveChat.enabled || document.getElementById('LiveChat')) {
      return;
    }

    const script = document.createElement('script');

    script.type = 'text/javascript';
    script.id = `LiveChat`;

    script.append(
      document.createTextNode(`
        window.__lc = window.__lc || {};
        window.__lc.license = 6236831;
        window.__lc.ga_version = 'gtm';
        window.__lc.params = [{ name: 'gaID', value: '${import.meta.env.VITE_SERVICE_GOOGLE_TAG_MANAGER_ID}' }];
        ;(function(n,t,c){function i(n){return e._h?e._h.apply(null,n):e._q.push(n)}var e={_q:[],_h:null,_v:"2.0",on:function(){i(["on",c.call(arguments)])},once:function(){i(["once",c.call(arguments)])},off:function(){i(["off",c.call(arguments)])},get:function(){if(!e._h)throw new Error("[LiveChatWidget] You can't use getters before load.");return i(["get",c.call(arguments)])},call:function(){i(["call",c.call(arguments)])},init:function(){var n=t.createElement("script");n.async=!0,n.type="text/javascript",n.src="https://cdn.livechatinc.com/tracking.js",t.head.appendChild(n)}};!n.__lc.asyncInit&&e.init(),n.LiveChatWidget=n.LiveChatWidget||e}(window,document,[].slice))`)
    );

    document.body.append(script);
  }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (window.LC_API && window.LC_API?.is_loaded()) {
        setIsWidgetLoaded(true);
        window.LC_API.hide_eye_catcher();
        clearInterval(intervalId);
      }
    }, 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  return {
    isWidgetLoaded,
    openChatWidget: () => {
      window.LC_API?.open_chat_window();
    },
    hideChatWidget: () => {
      window.LC_API?.hide_chat_window();
    },
    restoreChatWidget: () => {
      if (window.LC_API?.chat_window_hidden()) {
        window.LC_API.minimize_chat_window();
      }
    },
  };
};
